// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorSupplierProducts = (client) => ({
    /**
     * `POST /vendor/:supplierId/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSupplierProductsBulkImport
     * @source apps/backend/src/api/vendor/[supplierId]/products/route.ts
     */
    create: (supplierId, body, query, headers) => client.fetch(buildPath("/vendor/:supplierId/products", [supplierId]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/:supplierId/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSupplierProductsBulkRemove
     * @source apps/backend/src/api/vendor/[supplierId]/products/route.ts
     */
    delete: (supplierId, body, query, headers) => client.fetch(buildPath("/vendor/:supplierId/products", [supplierId]), { method: "DELETE", body, query, headers }),
});
//# sourceMappingURL=supplier-products.js.map